"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compTranslate = exports.Translate = void 0;
var answers_lib_1 = require("@wix/answers-lib");
/* tslint:disable */
var Translations = {
    en: {
        'public.user-toolbar.info.full-name': '{{firstName}} {{lastNameInitial}}.',
        'public.user-toolbar.info.name': '{{name}}',
        'public.user-toolbar.info.logged-in': 'logged in as',
        'public.user-toolbar.article.state.title': 'This article’s stats',
        'public.user-toolbar.article.manage.title': 'Manage this article',
        'public.user-toolbar.article.follow': 'Follow this Article',
        'public.user-toolbar.article.tooltip': 'Once checked, You will recieve a notification for every update made to this article',
        'public.user-toolbar.ticket.link': 'Go to ticket page',
        'public.user-toolbar.ticket.follow': 'Follow this Ticket',
        'public.user-toolbar.ticket.tooltip': 'Once checked, You will recieve a notification for every new reply in this ticket',
        'public.user-toolbar.category.follow': 'Follow Subcategory',
        'public.user-toolbar.category.tooltip': 'Once checked, You will recieve a notification for every new ticket opened in this subcategory',
        'public.user-toolbar.nav-tooltip.articles': 'Manage articles',
        'public.user-toolbar.nav-tooltip.tickets': 'Manage tickets',
        'common.permission.0': 'None',
        'common.permission.100': 'Root',
        'common.permission.20': 'Agent',
        'common.permission.80': 'Admin',
        'common.updated': 'Updated',
        'common.created': 'Created',
        'common.followers': 'Followers',
        'common.linked-tickets': 'Linked Tickets',
        'common.helpful': 'Helpful',
        'common.unhelpful': 'Unhelpful',
        'common.votes': 'Votes',
    }
};
// tslint:disable-next-line:max-line-length
exports.Translate = function (locale) { return answers_lib_1.createTranslateFn(Translations[locale] || Translations.en); };
exports.compTranslate = function (locale, prefix) {
    return function (key) { return exports.Translate(locale)(prefix + "." + key); };
};
//# sourceMappingURL=local-translations.js.map